import React, { useEffect, useState } from 'react';
import { getExpressParams, deleteExpressParams } from '../../../service/api';
import NoticePageMain from '../../presentation/section/notice-page/NoticePageMain';
import {useHistory} from 'react-router-dom';
import * as path from '../../../route/PathConfig';
import { connect } from 'react-redux';

const NoticePage = (props) => {
  let history = useHistory();

  const [noticeData, setNoticeData] = useState({
    noticeID: null,
    onTop: null,
    owner: null,
  });
  const [userRole, setUserRole] = useState('');

  useEffect(()=>{
    getExpressParams('/notice/noticeid', {
      noticeID: props.match.params.noticeID
    }, (response) => {
      response.data.noticeentity.forEach(item=>setNoticeData(item))
    })
    getExpressParams('/users/role/userid', {
      email: props.currentUser
    }, (response) => {
      setUserRole(response.data[0].role)
    })
  }, [])

  const handleDeleteBtn = (noticeID) => {
    deleteExpressParams('/notice/noticeid', {
      noticeID: noticeID,
    }, (response) => {
      history.push(`${path.NOTICE}`);
    })
  }
  
  return (
    <NoticePageMain noticeData={noticeData} handleDeleteBtn={handleDeleteBtn} userRole={userRole}/>
  )
}
const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser
});
export default connect(mapStateToProps) (NoticePage);